import { RegularText } from '@/lib/Text';
import { Col, Row } from '@/lib/utils';
import React from 'react';
import { StageCoachReviewInfo } from '@/features/centerReview';
import SvgIcon from '@/components/SvgIcon';
import { colors } from '@/lib/colors';
import { RatingStars } from '@/components/RatingStars';

type Props = {
    badgeNumber: number;
    label: string;
    stageData: StageCoachReviewInfo;
};

function ModalCoachReviewHeader({ badgeNumber, label, stageData }: Props) {
    const isIncrease = stageData.stageAverageRatingChange >= 0;
    const changeValue = Math.abs(stageData.stageAverageRatingChange).toFixed(1);

    return (
        <Col className="mb-[26px]">
            {/* 첫 번째 줄: 배지 + 회차명 + 별점 + 참여자 */}
            <Row className="items-center mb-[31px]">
                <SvgIcon
                    name={`SvgReviewNum${badgeNumber}` as 'SvgReviewNum1' | 'SvgReviewNum2' | 'SvgReviewNum3'}
                    size={27}
                    fill={colors.Text_1}
                    className="mr-[11px]"
                />
                <RegularText fontSize={20} lineHeight={27} color={'#191F28'} className="mr-[9px]">
                    {label}
                </RegularText>
            </Row>

            {/* 점수와 통계 */}
            <Row className="items-start mb-[42px]">
                {/* 왼쪽: 별점 */}
                <div className="mr-[32px]">
                    <RatingStars rating={stageData.stageAverageRating} size={22} gap={0} showScore={true} fs={45} />
                </div>

                {/* 오른쪽: 1개월 전보다, 의견수, 진행바 */}
                <Col className="flex-1">
                    {/* 1개월 전보다 */}
                    <div className="flex items-center mb-[8px]">
                        <RegularText
                            fontSize={16}
                            lineHeight={21}
                            color={colors.Text_1}
                            className="mr-[7px]"
                            letterSpacing={-0.7}
                        >
                            1개월 전보다
                        </RegularText>
                        <SvgIcon
                            name={'SvgSortArrow'}
                            size={12}
                            fill={isIncrease ? colors.GREEN : colors.ERROR}
                            className={`mr-[3px] ${isIncrease ? '' : 'transform rotate-180'}`}
                        />
                        <RegularText fontSize={14} lineHeight={20} color={isIncrease ? colors.GREEN : colors.ERROR}>
                            {changeValue}
                        </RegularText>
                    </div>

                    {/* 참여수 */}
                    <div className="flex items-center mb-[8px]">
                        <SvgIcon
                            name="SvgCheck"
                            size={14}
                            fill={colors.trans}
                            stroke={colors.Text_1}
                            className="mr-[6px]"
                        />
                        <RegularText fontSize={15} lineHeight={21} color={colors.Text_1}>
                            {stageData.stageReviewMemberCount.toLocaleString()}명 참여
                        </RegularText>
                    </div>

                    {/* 의견수 */}
                    <div className="flex items-center ">
                        <SvgIcon
                            name="SvgLineHistory"
                            size={14}
                            fill={colors.trans}
                            stroke={colors.Text_1}
                            className="mr-[6px]"
                        />
                        <RegularText fontSize={15} lineHeight={21} color={colors.Text_1}>
                            {stageData.stageAnswerCount.toLocaleString()}회 의견
                        </RegularText>
                    </div>
                </Col>
            </Row>
            <Col className="flex w-full h-[1px] bg-[#E6E8EA]" />
        </Col>
    );
}

export default ModalCoachReviewHeader;
